import React from "react";
import { useTranslation } from "react-i18next";
import { STATUS_CLASSES } from "@/lib/constants";
import { cn } from "@/lib/utils";

/** Status badge (content / lead / task / approval / appointment). Colour + label, never colour only. */
export const StatusPill = ({ status, label, className = "", testId }) => {
  const { t } = useTranslation();
  if (!status) return null;
  return (
    <span className={cn("inline-flex items-center whitespace-nowrap rounded-md border px-1.5 py-0.5 text-[11px] font-medium", STATUS_CLASSES[status] || STATUS_CLASSES.normal, className)} data-testid={testId || `status-pill-${status}`}>
      {label || t(`status.${status}`, { defaultValue: status })}
    </span>
  );
};

export const PriorityPill = ({ priority, className = "" }) => {
  const { t } = useTranslation();
  if (!priority) return null;
  return <StatusPill status={priority} label={t(`status.${priority}`, { defaultValue: priority })} className={className} testId={`priority-pill-${priority}`} />;
};
